import AppleGoogle from './images/apple-google.svg'
import Card from './images/card.svg'
import Ideal from './images/ideal.svg'
import PayId from './images/pay-id.svg'
import PayPal from './images/paypal.svg'
import Pix from './images/pix.svg'
import Sepa from './images/sepa.svg'
import YellowCard from './images/yellow-card.svg'

export const icons: { [key: string]: string } = {
  card: Card,
  IDEAL: Ideal,
  sepa_bank_transfer: Sepa,
  apple_pay: AppleGoogle,
  yellow_card_bank_transfer: YellowCard,
  pix: Pix,
  pay_id: PayId,
  pay_pal: PayPal,
}
